export const isEmpty = (value) => value === null || value === undefined || value === '';
export const extractDateStringOnIsoString = (isoString) => {
  const split = isoString.split('-');
  const month = split[1];
  const day = split[2].slice(0, 2);
  const year = split[0];

  return `${month}/${day}/${year}`;
};
export const censorMobileNumber = (mobileNumber) => {
  const censored = mobileNumber.slice(4, mobileNumber.length - 4);
  return mobileNumber.replace(censored, '*'.repeat(censored.length));
};
/**
 * Should be temporary because the number returned by the server
 *  is only the hardcoded last 4 digits
 * I think it should just be the number including the censored part
 * Following the implementation of mobile app for now...
 *
 * @param {Number} partialNumber
 */
export const claimSentToMobileNumberText = (partialNumber) => `+63******${partialNumber}`;
export const militaryTimeToStandard = (militaryTime, includeSeconds = false) => {
  const split = militaryTime.split(':');
  let hour = Number(split[0]);
  const meridiem = hour >= 12 ? 'PM' : 'AM';

  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour -= 12;
  }

  let time = `${hour}:${split[1]}`;

  if (includeSeconds) {
    time += `:${split[2]}`;
  }

  return `${time} ${meridiem}`;
};
export const bookDoctor = (userTag) => {
  const website = process.env.VUE_APP_API.replace('/api', '');
  window.open(`${website}/doctor/${userTag}`, '_blank');
};
export const formatAddressObjtoString = (addressObj) => {
  const _addressObj = addressObj || {};
  const preprocessor = (value, replaceValue) => (value || '').replace(/\n/g, replaceValue || ' ').trim();
  const finalRoomNumber = preprocessor(_addressObj.roomnumber);
  const finalStreet = preprocessor(_addressObj.street);
  const finalCity = preprocessor(_addressObj.city, ', ');

  return `${finalRoomNumber} ${finalStreet} ${finalCity}`
    .replace(/ {2}/g, ' ')
    .replace(/ ,/g, ',')
    .replace(/,,/g, ',')
    .replace(/, ,/g, ',');
};
export const formatStringSpaces = (string, count) => {
  const re = new RegExp(`.{1,${count}}`, 'gi');
  const stringSplit = string.match(re);
  return stringSplit.join(' ');
}

export const getCityValue = (cityObject) => {
  if (!cityObject) return;

  return `${cityObject.name}, ${cityObject.region}`;
};
export const getWatsonCityValue = (city) => `${city.cityname}, ${city.province}`;

export const getStaticImage = (path) => {
  if (path.startsWith('/profile_pictures')) {
    return `https://static.seriousmd.com${path}`;
  }

  if (path.startsWith('profile_pictures')) {
    return `https://static.seriousmd.com/${path}`;
  }

  return path;
};
